import { CREATININE_CONVERSION } from "./calculators/constants";

/**
 * Converts creatinine value to micromoles per litre (micromol/L)
 * @param {number|string} value - The creatinine value
 * @param {string} unit - The unit of the creatinine value ("micromoles/L", "mg/dL", "millimoles/L")
 * @returns {number} - The creatinine value in micromol/L
 */
export function getCreatinineInMicromol(value, unit) {
  const numValue = Number(value);
  
  if (isNaN(numValue)) {
    return NaN;
  }

  switch (unit) {
    case "mg/dL":
      return numValue * CREATININE_CONVERSION.MG_DL_TO_MICROMOL_L;
    case "millimoles/L":
      return numValue * CREATININE_CONVERSION.MILLIMOL_L_TO_MICROMOL_L;
    case "micromoles/L":
    default:
      return numValue;
  }
}

/**
 * Converts creatinine value from micromol/L to the specified unit
 * @param {number} value - The creatinine value in micromol/L
 * @param {string} toUnit - The target unit ("micromoles/L", "mg/dL", "millimoles/L")
 * @returns {number} - The creatinine value in the target unit
 */
export function convertCreatinineFromMicromol(value, toUnit) {
  const numValue = Number(value);
  
  if (isNaN(numValue)) {
    return NaN;
  }

  switch (toUnit) {
    case "mg/dL":
      return numValue * CREATININE_CONVERSION.MICROMOL_L_TO_MG_DL;
    case "millimoles/L":
      return numValue * CREATININE_CONVERSION.MICROMOL_L_TO_MILLIMOL_L;
    case "micromoles/L":
    default:
      return numValue;
  }
}
